export const prettifyNumber = (numb) => {
  var str = String(numb).split('.');
  str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return str.join('.');
};
